import { BasicInfo } from '../../../../../utils/types/types';
import { BaseBuyerServiceV3 } from '../../../base-buyer.service';

class BuyerService extends BaseBuyerServiceV3 {
  public async fetchOrganizations(type: string): Promise<BasicInfo[]> {
    const response = await this.get<BasicInfo[]>(
      `/organizations/base-info?profileType=${type}`
    );
    return response.data;
  }
}

const buyerServiceV3 = new BuyerService();
export default buyerServiceV3;
